import React from 'react';

// Components
import { Tooltip } from '../tooltips';

// Libraries
import { Button, ButtonGroup, ButtonProps, Dropdown, DropdownProps } from 'react-bootstrap';
import { DropdownItemProps } from 'react-bootstrap/DropdownItem';
import uniqueId from 'lodash/uniqueId';

// Types
import { tooltipPlacement } from '@/types/tooltip';

export type DropdownButtonProps = DropdownProps &
  ButtonProps & {
    btnOnClick: () => void;
    disabled?: boolean;
    items: Array<DropdownButtonMenuItem>;
  };

export type DropdownButtonMenuItem = Omit<DropdownItemProps<string>, 'href'> & {
  hidden?: boolean;
  icon?: string | JSX.Element;
  node: React.ReactNode;
  tooltip?: {
    message: string;
    place?: tooltipPlacement;
  };
};

const DropdownSplitButton: React.FC<DropdownButtonProps> = ({ btnOnClick, children, disabled, items, variant, ...rest }) => {
  const id = uniqueId('dropdown-split-button-v2-');

  return (
    <Dropdown as={ButtonGroup} className="dropdown-split-button-v2" {...rest}>
      <Button className={`button ${variant} ${variant}-v2`} onClick={btnOnClick} variant={variant} disabled={disabled}>
        {children}
      </Button>

      <Dropdown.Toggle data-testid="dropdown-toggle" id={id} split className={`button ${variant} ${variant}-v2`} disabled={disabled} />

      <Dropdown.Menu as="ul" role="menu">
        {items.map(({ hidden, icon, node, onClick, tooltip }, index) =>
          hidden ? null : (
            <li key={index} role="presentation">
              <Tooltip disabled={!tooltip} message={tooltip?.message} place={tooltip?.place}>
                <Dropdown.Item as="button" onClick={onClick} role="menuitem" type="button">
                  {icon && typeof icon === 'string' ? <i className={`icon-${icon}`} /> : icon}
                  {node}
                </Dropdown.Item>
              </Tooltip>
            </li>
          ),
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropdownSplitButton;
